/**
 * @description 存放处理用户信息相关的函数，
 * 必须为纯函数，非纯函数别放这里
 */
import { AppStore } from 'src/pc/store/AppStore'
import Cookies from 'js-cookie'

/**
 * 获取用户登录的 token
 */
export const getPhpToken = () => {
  return localStorage.getItem('php-token') || undefined
}

/** 清除用户登录的 token */
const clearPhpToken = () => {
  localStorage.removeItem('php-token')
}

/** 保存用户退出登录时需要执行的回调 */
const clearAuthStatusFnArr: Function[] = []

/** 用户退出时 需要清除状态的方法注册进来， */
export const registerClearAuthStatusFn = (fn: Function) => {
  clearAuthStatusFnArr.push(fn)
}

/** 处理退出登录 */
export const handleLogout = (callback?: Function) => {
  const token = getPhpToken()
  if (token) {
    clearAuthStatusFnArr.forEach(fn => {
      fn && typeof fn === 'function' && fn?.()
    })
    clearPhpToken()
    // 用于卸载页
    Cookies.remove('current_userid')
    /** 这个不知道干嘛的 */
    localStorage.removeItem('ShowedNewUserGift')
    /** 暂时没用，先留着 */
    sessionStorage.removeItem('nine_one_modal')
    /** 实名认证弹框弹出记录 */
    localStorage.removeItem('realNameAuthModal')

    /** 离开支付页确认弹框（有优惠券） */
    localStorage.removeItem('leaveConfirmVisible')
    /** 年卡会员升级永久会员弹窗 */
    localStorage.removeItem('year-update-forever-modal-start')
    localStorage.removeItem('year-update-forever-modal-home')
    localStorage.removeItem('year-update-forever-modal-game')
    localStorage.removeItem('start-game-success-num')

    /** 会员到期弹窗弹出记录 */
    localStorage.removeItem('expiration-reminder-flag')

    /*退出登录通知客户端*/
    if (window.FuluApp) {
      window.FuluApp.JSNotifyCppFunc('need_user_logon')
      window.FuluApp.JSNotifyCppFunc('user_logout')
      //隐藏加速球
      AppStore.speedBall?.hide()
      window.FuluApp?.JSNotifyCppFunc('client2speed_msg', JSON.stringify({ __type__: 'clearToken' }))
    }
  }
  Cookies.remove('Authorization')
  callback?.()
}
